module.exports = __webpack_public_path__ + "static/media/Justine Triola.93d9629d.png";